//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">MT4账户绑定流程</div>
                  <p class="bold">
                      1.在VPS中登录MT4交易账户
                  </p>
                  <p>
                      1.1 使用VPS内置MT4交易软件登录账户，如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 软件打开后，在左侧导航Expert Advisors 列表中，可以看到WikiFXDefense天眼盾脚本。如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 交易账号登录成功后，天眼盾脚本会自动加载到窗口中，如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 若Status状态显示为7个1，则表示账户绑定成功(天眼盾脚本只做账户检测。不涉及任何交易，所以无需设置自动交易，即WikiFXDefense后的图标显示状态(笑脸或是哭脸)无需关注)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 若Status状态未显示7个1，可参考<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">常见问题处理</a>方式。
                  </p>
                  <p>
                      1.6 若WikiFXDefense脚本未出现在品种走势窗口中，则可以手动加载(参考：<span>MT4手动加载WikiFXDefense天眼盾脚本方法</span>)。
                  </p>
                  <p class="bold">
                      2、用户自己安装MT4进行登录操作
                  </p>
                  <p>
                      2.1 打开安装的MT4软件：(此处省略安装步骤)。打开后，若左侧导航中未出现WikiFXDefense天眼盾脚本，如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 可选中 “Expert Advisors”，右键选择”Refresh”，通常情况WikiFX Defense天眼盾脚本会自动显示在列表中。(<span>若仍无显示，可再等待片刻重试，或者联系在线客服协助解决</span>)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 账户登录成功后，手动将WikiFXDefense天眼盾脚本加载到窗口中，完成账户绑定操作。
                  </p>
                  <p>
                      注：<span>账户绑定成功后，天眼盾脚本需一直持续加载(只需要一个窗口加载即可)。</span>若关闭该窗口或在该窗口加载其他EA，则会弹出禁止关闭的提示，如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 用户如需使用其他EA，可以在新窗口中加载(见后面所述：MT4打开品种窗口方式)。
                  </p>
                  <p class="bold">
                      3、MT4手动加载WikiFXDefense天眼盾脚本方法(同正常加载其他EA方法)
                  </p>
                  <p>
                      方法1：点击需要加载WikiFXDefense脚本的品种窗口，使其处于激活状态。然后双击导航列表中的WikiFXDefense脚本，弹出加载提示窗口，点击OK按钮即可。如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      方法2：点击鼠标左键，将导航列表中的WikiFXDefense脚本拖入需要加载的品种窗口中，弹出加载提示窗口，点击OK按钮即可。
                  </p>
                  <p class="bold">
                      4、MT4打开品种窗口方式
                  </p>
                  <p>
                      方法1： 在左侧市场列表中，选中需要打开的品种，点击鼠标右键，选择： “Chart Window”。 如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      方法2： 在菜单”Window” 中，选择”New Window”，然后选择需要打开的品种。如图所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        zh: `
        <div class="title-box">MT4帳戶綁定流程</div>
                  <p class="bold">
                      一、在VPS中登入MT4交易帳戶
                  </p>
                  <p>
                      1、使用VPS內建MT4交易軟體登入帳號，如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      2、軟體開啟後，在左側導覽Expert Advisors 清單中，可以看到WikiFXDefense天眼盾腳本。如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      3.交易帳號登入成功後，天眼盾腳本會自動載入到視窗中，如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      4.若Status狀態顯示為7個1，則表示帳戶綁定成功，(天眼盾腳本只做帳戶檢測，不涉及任何交易，所以無需設置自動交易，即WikiFXDefense後的圖標顯示狀態(笑臉或是哭 臉)無需關注)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      5.若Status狀態未顯示7個1，可參考<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">常見問題處理</a>方式。
                  </p>
                  <p>
                      6.若WikiFXDefense腳本未出現在品種走勢窗口中，則可以手動加載(參考： <span>MT4手動加載WikiFXDefense天眼盾腳本方法</span>)。
                  </p>
                  <p class="bold">
                      二、用戶自行安裝MT4進行登入操作
                  </p>
                  <p>
                      1、開啟安裝的MT4軟體：(此處省略安裝步驟)。 打開後，若左側導覽未出現WikiFXDefense天眼盾腳本，如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2、選用中 “Expert Advisors”，右鍵選擇”Refresh”，通常情況WikiFX Defense天眼盾腳本會自動顯示在列表中。(<span>若仍無顯示，可再等待片刻重試，或者聯繫在線客服協助解決</span>)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      3.帳戶登入成功後，手動將WikiFXDefense天眼盾腳本載入到視窗中，完成帳戶綁定操作。
                  </p>
                  <p>
                      註：<span>帳戶綁定成功後，天眼盾腳本需一直持續載入(只需要一個視窗載入即可)。</span> 若關閉該視窗或在該視窗載入其他EA，則會彈出禁止關閉的提示，如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      4.使用者如需使用其他EA，可以在新視窗中載入(見後面所述： MT4開啟品種視窗方式)。
                  </p>
                  <p class="bold">
                      三、MT4手動載入WikiFXDefense天眼盾腳本方法(同正常載入其他EA方法)
                  </p>
                  <p>
                      方法1：點選需要載入WikiFXDefense腳本的品種視窗，使其處於啟動狀態。然後雙擊導覽清單中的WikiFXDefense腳本，彈出載入提示視窗，點選OK按鈕即可。如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      方法2：點選滑鼠左鍵，將導覽清單中的WikiFXDefense腳本拖曳到需要載入的品種視窗中，彈出載入提示視窗，點擊OK按鈕即可。
                  </p>
                  <p class="bold">
                      四、MT4開品種窗方式
                  </p>
                  <p>
                      方法1： 在左側市場清單中，選取需要開啟的品種，點選滑鼠右鍵，選擇： “Chart Window”。 如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      方法2： 在選單”Window” 中，選擇”New Window”，然後選擇需要打開的品種。如圖所示：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        en: `
        <div class="title-box">MT4 account binding process</div>
                  <p class="bold">
                      Log in to the MT4 trading account in the VPS
                  </p>
                  <p>
                      1.1 Use the VPS built-in MT4 trading software to log in to your account, as shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 After the software is opened, you can see the WikiFXDefense Sky Eye Shield script in the Expert Advisors list on the left navigation. As shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 After successfully logging in to the trading account, the Sky Eye Shield script will be automatically loaded into the window, as shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 If the Status shows 7 1s, it means that the account binding is successful (the Sky Eye Shield script only does account detection and does not involve any transactions, so there is no need to set up automatic transactions, that is, the icon display status after WikiFXDefense (smiling face or crying face) )No need to pay attention)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 If the Status does not show 7 1s, please refer to the <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQs</a>.
                  </p>
                  <p>
                      1.6 If the WikiFXDefense script does not appear in the variety trend window, it can be loaded manually (reference: MT4 manual loading method of WikiFXDefense Sky Eye Shield script).
                  </p>

                          <p class="bold">
                              Users install MT4 themselves and log in.
                          </p>

                  <p>
                      2.1 Open the installed MT4 software: (the installation steps are omitted here). After opening, if the WikiFXDefense Sky Eye Shield script does not appear in the left navigation, as shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 You can select &quot;Expert Advisors&quot;, right-click and select &quot;Refresh&quot;. Normally, the WikiFX Defense Sky Eye Shield script will automatically appear in the list. (If it is still not displayed, you can wait a moment and try again, or contact online customer service for assistance)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 After the account is successfully logged in, manually load the WikiFXDefense Sky Eye Shield script into the window to complete the account binding operation.
                  </p>
                  <p>
                      Note: After the account is successfully bound, the Sky Eye Shield script needs to be loaded continuously (only one window is required to load). If you close this window or load other EAs in this window, a prompt prohibiting closing will pop up, as shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 If users need to use other EAs, they can load them in a new window (see later: How to open the variety window in MT4).
                  </p>

                          <p class="bold">
                              MT4 manual loading method of WikiFXDefense Sky Eye Shield script (same as normal loading of other EA methods)
                          </p>

                  <p>
                      Method 1: Click on the product window that needs to load the WikiFXDefense script to make it active. Then double-click the WikiFXDefense script in the navigation list, a loading prompt window will pop up, and click the OK button. As shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Method 2: Click the left mouse button, drag the WikiFXDefense script in the navigation list into the window of the product that needs to be loaded, a loading prompt window will pop up, and click the OK button.
                  </p>

                          <p class="bold">
                              How to open the variety window in MT4
                          </p>

                  <p>
                      Method 1: In the market list on the left, select the variety you want to open, right-click the mouse and select: “Chart Window”. As shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Method 2: In the menu &quot;Window&quot;, select &quot;New Window&quot;, and then select the variety you want to open. As shown in the figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        ru: `
        <div class="title-box">Процесс привязки аккаунта МТ4</div>
                          <p class="bold">
                              Войдите в торговый счет MT4 на VPS.
                          </p>
                  <p>
                      1.1 Используйте встроенное торговое программное обеспечение MT4 VPS для входа в свою учетную запись, как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 После открытия программного обеспечения вы увидите скрипт WikiFXDefense Sky Eye Shield в списке советников на левой панели навигации, как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 После успешного входа в торговый счет в окно автоматически загрузится скрипт Sky Eye Shield, как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Если в Статусе указано 7 1, это означает, что привязка аккаунта прошла успешно (скрипт Sky Eye Shield занимается только определением аккаунта и не предполагает никаких транзакций, поэтому нет необходимости настраивать автоматические транзакции, то есть отображение значка статус после WikiFXDefense (улыбающееся лицо или плачущее лицо)) Не нужно обращать внимание)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Если в статусе не отображается 7 1, обратитесь <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">к часто задаваемым вопросам</a>.
                  </p>
                  <p>
                      1.6 Если скрипт WikiFXDefense не отображается в окне тренда разнообразия, его можно загрузить вручную (ссылка: метод ручной загрузки скрипта WikiFXDefense Sky Eye Shield в MT4).
                  </p>

                          <p class="bold">
                              Пользователи сами устанавливают МТ4 и авторизуются.
                          </p>

                  <p>
                      2.1 Откройте установленное программное обеспечение MT4: (этапы установки здесь опущены). Если после открытия скрипт WikiFXDefense Sky Eye Shield не отображается в левой навигации, как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Вы можете выбрать «Эксперты», щелкнуть правой кнопкой мыши и выбрать «Обновить». Обычно скрипт WikiFX Defense Sky Eye Shield автоматически появляется в списке (если он по-прежнему не отображается, вы можете подождать немного и повторить попытку. или обратитесь за помощью в онлайн-службу поддержки клиентов)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 После успешного входа в учетную запись вручную загрузите в окно скрипт WikiFXDefense Sky Eye Shield, чтобы завершить операцию привязки учетной записи.
                  </p>
                  <p>
                      Примечание. После успешной привязки учетной записи скрипт Sky Eye Shield необходимо загружать постоянно (для загрузки требуется только одно окно). Если вы закроете это окно или загрузите в это окно другие советники, то всплывет приглашение, запрещающее закрытие. как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Если пользователям необходимо использовать другие советники, они могут загрузить их в новом окне (см. далее: Как открыть окно разнообразия в MT4).
                  </p>

                          <p class="bold">
                              Метод ручной загрузки скрипта WikiFXDefense Sky Eye Shield в MT4 (так же, как и обычная загрузка других методов советника)
                          </p>

                  <p>
                      Способ 1. Щелкните окно продукта, в котором необходимо загрузить сценарий WikiFXDefense, чтобы сделать его активным. Затем дважды щелкните сценарий WikiFXDefense в списке навигации, появится всплывающее окно с подсказкой о загрузке, и нажмите кнопку «ОК», как показано на рисунке. фигура:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Способ 2: Нажмите левую кнопку мыши, перетащите скрипт WikiFXDefense в списке навигации в окно продукта, который необходимо загрузить, появится окно с подсказкой о загрузке, и нажмите кнопку ОК.
                  </p>

                          <p class="bold">
                              Как открыть окно разнообразия в МТ4
                          </p>

                  <p>
                      Способ 1: В списке рынков слева выберите сорт, который хотите открыть, щелкните правой кнопкой мыши и выберите: «Окно графика». Как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Способ 2: В меню «Окно» выберите «Новое окно», а затем выберите сорт, который хотите открыть Как показано на рисунке:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        ja: `
        <div class="title-box">MT4アカウントバインドプロセス</div>
                  <p>
                      MT4アカウントバインドプロセス
                  </p>
                          <p class="bold">
                              VPSでMT4取引口座にログインします。
                          </p>
                  <p>
                      1.1 図に示すように、VPS 内蔵 MT4 取引ソフトウェアを使用してアカウントにログインします。
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 ソフトウェアを開いた後、図に示すように、左側のナビゲーションの Expert Advisors リストに WikiFX Defense Sky Eye Shield スクリプトが表示されます。
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 取引口座へのログインに成功すると、図に示すように、Sky Eye Shield スクリプトがウィンドウに自動的にロードされます。
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 ステータスに 7 つの 1 が表示されている場合は、アカウントのバインドが成功したことを意味します (Sky Eye Shield スクリプトはアカウントの検出のみを行い、トランザクションには関与しないため、自動トランザクション、つまりアイコン表示を設定する必要はありません) WikiFXDefence後のステータス（笑顔または泣き顔）（特に気にする必要はありません）
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 ステータスに 1 が 7 つ表示されない場合は、<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a> を参照してください。
                  </p>
                  <p>
                      1.6 WikiFX Defense スクリプトがバラエティ トレンド ウィンドウに表示されない場合は、手動でロードできます (参考: WikiFX Defense Sky Eye Shield スクリプトの MT4 手動ロード方法)。
                  </p>

                          <p class="bold">
                              ユーザー自身がMT4をインストールし、ログインします。
                          </p>

                  <p>
                      2.1 インストールした MT4 ソフトウェアを開きます (インストール手順はここでは省略します)。 開いた後、図に示すように、WikiFX Defense Sky Eye Shield スクリプトが左側のナビゲーションに表示されない場合:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 [エキスパート アドバイザー] を選択し、右クリックして [更新] を選択すると、通常、WikiFX Defense Sky Eye Shield スクリプトがリストに自動的に表示されます (それでも表示されない場合は、少し待ってから再試行してください)。 、またはオンライン カスタマー サービスにお問い合わせください)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 アカウントが正常にログインしたら、WikiFX Defense Sky Eye Shield スクリプトをウィンドウに手動でロードして、アカウント バインド操作を完了します。
                  </p>
                  <p>
                      注: アカウントが正常にバインドされた後、Sky Eye Shield スクリプトを継続的にロードする必要があります (ロードするのに必要なウィンドウは 1 つだけです)。このウィンドウを閉じるか、このウィンドウで他の EA をロードすると、閉じることを禁止するプロンプトが表示されます。図に示すように:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 ユーザーが他の EA を使用する必要がある場合、それらを新しいウィンドウにロードできます (後述: MT4 でさまざまなウィンドウを開く方法を参照)。
                  </p>

                          <p class="bold">
                              WikiFX Defense Sky Eye ShieldスクリプトのMT4手動ロード方法（他のEAメソッドの通常のロードと同じ）
                          </p>

                  <p>
                      方法 1: WikiFX Defense スクリプトをロードする必要がある製品ウィンドウをクリックしてアクティブにし、ナビゲーション リストで WikiFX Defense スクリプトをダブルクリックすると、ロード プロンプト ウィンドウが表示され、[OK] ボタンをクリックします。形：
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      方法 2: マウスの左ボタンをクリックし、ナビゲーション リスト内の WikiFX Defense スクリプトをロードする必要がある製品のウィンドウにドラッグします。ロード プロンプト ウィンドウがポップアップ表示され、[OK] ボタンをクリックします。
                  </p>
                  <p>
                      4.MT4でバラエティウィンドウを開く方法
                  </p>
                  <p>
                      方法 1: 左側の市場リストで、開きたい銘柄を選択し、マウスを右クリックして「チャート ウィンドウ」を選択します。
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      方法 2: メニューの「ウィンドウ」で「新しいウィンドウ」を選択し、開きたいウィンドウを選択します。図に示すように:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        th: `
        <div class="title-box">กระบวนการผูกบัญชี MT4</div>
                          <p class="bold">
                              เข้าสู่ระบบบัญชีซื้อขาย MT4 ใน VPS
                          </p>
                  <p>
                      1.1 ใช้ซอฟต์แวร์การซื้อขาย MT4 ในตัว VPS เพื่อเข้าสู่บัญชีของคุณ ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 หลังจากเปิดซอฟต์แวร์แล้ว คุณจะเห็นสคริปต์ WikiFXDefense Sky Eye Shield ในรายการ Expert Advisors ทางด้านซ้าย ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 หลังจากเข้าสู่ระบบบัญชีซื้อขายสำเร็จแล้ว สคริปต์ Sky Eye Shield จะถูกโหลดลงในหน้าต่างโดยอัตโนมัติ ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 หากสถานะแสดง 7 1 แสดงว่าผูกบัญชีสำเร็จแล้ว (สคริปต์ Sky Eye Shield ทำหน้าที่ตรวจสอบบัญชีเท่านั้นและไม่เกี่ยวข้องกับธุรกรรมใด ๆ ดังนั้นจึงไม่จำเป็นต้องตั้งค่าธุรกรรมอัตโนมัตินั่นคือไอคอนแสดง สถานะหลัง WikiFXDefense (หน้ายิ้มหรือหน้าร้องไห้) )ไม่ต้องสนใจ)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 หากสถานะไม่แสดง 7 1 โปรด<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">ดูที่คำถามที่พบบ่อย</a>
                  </p>
                  <p>
                      1.6 หากสคริปต์ WikiFXDefense ไม่ปรากฏในหน้าต่างแนวโน้มหลากหลาย สามารถโหลดได้ด้วยตนเอง (อ้างอิง: วิธีการโหลด MT4 ด้วยตนเองของสคริปต์ WikiFXDefense Sky Eye Shield)
                  </p>

                          <p class="bold">
                              ผู้ใช้ติดตั้ง MT4 ด้วยตนเองและเข้าสู่ระบบ
                          </p>

                  <p>
                      2.1 เปิดซอฟต์แวร์ MT4 ที่ติดตั้ง: (ขั้นตอนการติดตั้งจะถูกละไว้ที่นี่) หลังจากเปิดขึ้น หากสคริปต์ WikiFXDefense Sky Eye Shield ไม่ปรากฏในการนำทางด้านซ้าย ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 คุณสามารถเลือก &quot;ที่ปรึกษาผู้เชี่ยวชาญ&quot; คลิกขวาและเลือก &quot;รีเฟรช&quot; โดยปกติสคริปต์ WikiFX Defense Sky Eye Shield จะปรากฏในรายการโดยอัตโนมัติ (หากยังไม่แสดง คุณสามารถรอสักครู่แล้วลองอีกครั้ง หรือติดต่อฝ่ายบริการลูกค้าออนไลน์เพื่อขอความช่วยเหลือ)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 หลังจากที่บัญชีเข้าสู่ระบบสำเร็จแล้ว ให้โหลดสคริปต์ WikiFXDefense Sky Eye Shield ด้วยตนเองลงในหน้าต่างเพื่อดำเนินการผูกบัญชีให้เสร็จสิ้น
                  </p>
                  <p>
                      หมายเหตุ: หลังจากที่ผูกบัญชีสำเร็จแล้ว จะต้องโหลดสคริปต์ Sky Eye Shield อย่างต่อเนื่อง (ต้องโหลดเพียงหน้าต่างเดียวเท่านั้น) หากคุณปิดหน้าต่างนี้หรือโหลด EA อื่น ๆ ในหน้าต่างนี้ ข้อความแจ้งห้ามปิดจะปรากฏขึ้น ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 หากผู้ใช้จำเป็นต้องใช้ EA อื่นๆ พวกเขาสามารถโหลดได้ในหน้าต่างใหม่ (ดูในภายหลัง: วิธีเปิดหน้าต่างวาไรตี้ใน MT4)
                  </p>

                          <p class="bold">
                              วิธีการโหลด MT4 ด้วยตนเองของสคริปต์ WikiFXDefense Sky Eye Shield (เหมือนกับการโหลดวิธี EA อื่น ๆ ตามปกติ)
                          </p>

                  <p>
                      วิธีที่ 1: คลิกที่หน้าต่างผลิตภัณฑ์ที่ต้องการโหลดสคริปต์ WikiFXDefense เพื่อให้ใช้งานได้ จากนั้นดับเบิลคลิกที่สคริปต์ WikiFXDefense ในรายการนำทาง หน้าต่างพร้อมท์การโหลดจะปรากฏขึ้น และคลิกปุ่ม OK ดังที่แสดงใน รูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      วิธีที่ 2: คลิกปุ่มซ้ายของเมาส์ ลากสคริปต์ WikiFXDefense ในรายการการนำทางไปยังหน้าต่างของผลิตภัณฑ์ที่ต้องการโหลด หน้าต่างพร้อมท์การโหลดจะปรากฏขึ้น และคลิกปุ่มตกลง
                  </p>

                          <p class="bold">
                              วิธีเปิดหน้าต่างวาไรตี้ใน MT4
                          </p>

                  <p>
                      วิธีที่ 1: ในรายการตลาดทางด้านซ้าย เลือกความหลากหลายที่คุณต้องการเปิด คลิกขวาที่เมาส์แล้วเลือก: “หน้าต่างแผนภูมิ” ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      วิธีที่ 2: ในเมนู &quot;หน้าต่าง&quot; เลือก &quot;หน้าต่างใหม่&quot; จากนั้นเลือกความหลากหลายที่คุณต้องการเปิด ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        vi: `
        <div class="title-box">Quy trình ràng buộc tài khoản MT4</div>
                          <p class="bold">
                              Đăng nhập tài khoản giao dịch MT4 trên VPS
                          </p>
                  <p>
                      1.1 Sử dụng phần mềm giao dịch MT4 tích hợp trên VPS để đăng nhập vào tài khoản như hình:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Sau khi mở phần mềm, bạn có thể thấy tập lệnh WikiFXDefense Sky Eye Shield trong danh sách Expert Advisors ở điều hướng bên trái. Như trong hình:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Sau khi đăng nhập thành công vào tài khoản giao dịch, tập lệnh Sky Eye Shield sẽ tự động được tải vào cửa sổ, như trong hình:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Nếu Trạng thái hiển thị 7 1s nghĩa là liên kết tài khoản thành công (tập lệnh Sky Eye Shield chỉ phát hiện tài khoản và không liên quan đến bất kỳ giao dịch nào nên không cần thiết lập giao dịch tự động, tức là hiển thị biểu tượng trạng thái sau WikiFXDefense (mặt cười hoặc mặt khóc)) Không cần chú ý)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Nếu Trạng thái không hiển thị 7 1, vui lòng tham <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">khảo Câu hỏi thường gặp.</a>
                  </p>
                  <p>
                      1.6 Nếu tập lệnh WikiFXDefense không xuất hiện trong cửa sổ xu hướng đa dạng, nó có thể được tải thủ công (tham khảo: phương pháp tải thủ công MT4 của tập lệnh WikiFXDefense Sky Eye Shield).
                  </p>

                          <p class="bold">
                              Người dùng tự cài đặt MT4 và đăng nhập.
                          </p>

                  <p>
                      2.1 Mở phần mềm MT4 đã cài đặt: (ở đây bỏ qua các bước cài đặt). Sau khi mở, nếu tập lệnh WikiFXDefense Sky Eye Shield không xuất hiện trong điều hướng bên trái, như trong hình:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Bạn có thể chọn &quot;Expert Advisors&quot;, nhấp chuột phải và chọn &quot;Refresh&quot;. Thông thường, tập lệnh WikiFX Defense Sky Eye Shield sẽ tự động xuất hiện trong danh sách (Nếu nó vẫn không hiển thị, bạn có thể đợi một lát và thử lại. , hoặc liên hệ bộ phận chăm sóc khách hàng trực tuyến để được hỗ trợ)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Sau khi đăng nhập thành công tài khoản, hãy tải tập lệnh WikiFXDefense Sky Eye Shield theo cách thủ công vào cửa sổ để hoàn tất thao tác ràng buộc tài khoản.
                  </p>
                  <p>
                      Lưu ý: Sau khi tài khoản được liên kết thành công, tập lệnh Sky Eye Shield cần được tải liên tục (chỉ cần tải một cửa sổ để tải). Nếu bạn đóng cửa sổ này hoặc tải các EA khác trong cửa sổ này, một lời nhắc cấm đóng sẽ bật lên, như thể hiện trong hình:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Nếu người dùng cần sử dụng các EA khác, họ có thể tải chúng trong một cửa sổ mới (xem sau: Cách mở cửa sổ đa dạng trong MT4).
                  </p>

                          <p class="bold">
                              Phương thức tải thủ công MT4 của tập lệnh WikiFXDefense Sky Eye Shield (giống như tải thông thường các phương pháp EA khác)
                          </p>

                  <p>
                      Phương pháp 1: Nhấp vào cửa sổ sản phẩm cần tải tập lệnh WikiFXDefense để kích hoạt. Sau đó nhấp đúp vào tập lệnh WikiFXDefense trong danh sách điều hướng, một cửa sổ nhắc tải sẽ bật lên và nhấp vào nút OK. nhân vật:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Phương pháp 2: Nhấp chuột trái, kéo tập lệnh WikiFXDefense trong danh sách điều hướng vào cửa sổ của sản phẩm cần tải, cửa sổ nhắc tải sẽ bật lên và nhấp vào nút OK.
                  </p>

                          <p class="bold">
                              Cách mở cửa sổ đa dạng trong MT4
                          </p>

                  <p>
                      Cách 1: Trong danh sách thị trường bên trái, chọn giống bạn muốn mở, nhấp chuột phải và chọn: “Cửa sổ biểu đồ”.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Phương pháp 2: Trong menu &quot;Cửa sổ&quot;, chọn &quot;Cửa sổ mới&quot;, sau đó chọn loại bạn muốn mở như trong hình:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        id: `
        <div class="title-box">Proses pengikatan akun MT4</div>
                          <p class="bold">
                              Masuk ke akun perdagangan MT4 di VPS
                          </p>
                  <p>
                      1.1 Gunakan perangkat lunak perdagangan MT4 bawaan VPS untuk masuk ke akun Anda, seperti yang ditunjukkan pada gambar:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Setelah perangkat lunak dibuka, Anda dapat melihat skrip WikiFXDefense Sky Eye Shield di daftar Expert Advisors di navigasi kiri.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Setelah berhasil login ke akun trading, skrip Sky Eye Shield akan otomatis dimuat ke jendela, seperti yang ditunjukkan pada gambar:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Jika Status menunjukkan 7 1s, berarti pengikatan akun berhasil (script Sky Eye Shield hanya melakukan deteksi akun dan tidak melibatkan transaksi apa pun, jadi tidak perlu mengatur transaksi otomatis, yaitu tampilan ikon status setelah WikiFXDefense (wajah tersenyum atau wajah menangis) )Tidak perlu diperhatikan)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Jika Status tidak menunjukkan 7 1, silakan merujuk ke <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>.
                  </p>
                  <p>
                      1.6 Jika skrip WikiFXDefense tidak muncul di jendela variasi tren, skrip tersebut dapat dimuat secara manual (referensi: Metode pemuatan manual MT4 dari skrip WikiFXDefense Sky Eye Shield).
                  </p>

                          <p class="bold">
                              Pengguna menginstal MT4 sendiri dan login.
                          </p>

                  <p>
                      2.1 Buka perangkat lunak MT4 yang diinstal: (langkah-langkah instalasi dihilangkan di sini). Setelah dibuka, jika script WikiFXDefense Sky Eye Shield tidak muncul pada navigasi sebelah kiri, seperti terlihat pada gambar:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Anda dapat memilih &quot;Expert Advisors&quot;, klik kanan dan pilih &quot;Refresh&quot;. Biasanya, skrip WikiFX Defense Sky Eye Shield akan otomatis muncul di daftar (Jika masih tidak ditampilkan, Anda dapat menunggu sebentar dan coba lagi , atau hubungi layanan pelanggan online untuk mendapatkan bantuan)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Setelah akun berhasil masuk, muat secara manual skrip WikiFXDefense Sky Eye Shield ke dalam jendela untuk menyelesaikan operasi pengikatan akun.
                  </p>
                  <p>
                      Catatan: Setelah akun berhasil diikat, skrip Sky Eye Shield perlu dimuat secara terus-menerus (hanya diperlukan satu jendela untuk memuat). Jika Anda menutup jendela ini atau memuat EA lain di jendela ini, pesan larangan penutupan akan muncul. seperti yang ditunjukkan pada gambar:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Jika pengguna perlu menggunakan EA lain, mereka dapat memuatnya di jendela baru (lihat nanti: Cara membuka jendela variasi di MT4).
                  </p>

                          <p class="bold">
                              Metode pemuatan manual MT4 dari skrip WikiFXDefense Sky Eye Shield (sama seperti pemuatan normal metode EA lainnya)
                          </p>

                  <p>
                      Metode 1: Klik pada jendela produk yang perlu memuat skrip WikiFXDefense untuk mengaktifkannya. Kemudian klik dua kali skrip WikiFXDefense di daftar navigasi, jendela prompt pemuatan akan muncul, dan klik tombol OK angka:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Metode 2: Klik tombol kiri mouse, seret skrip WikiFXDefense di daftar navigasi ke jendela produk yang perlu dimuat, jendela perintah pemuatan akan muncul, dan klik tombol OK.
                  </p>

                          <p class="bold">
                              Cara membuka jendela variasi di MT4
                          </p>

                  <p>
                      Metode 1: Pada daftar pasar di sebelah kiri, pilih variasi yang ingin Anda buka, klik kanan mouse dan pilih: “Jendela Bagan”.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Metode 2: Di menu &quot;Jendela&quot;, pilih &quot;Jendela Baru&quot;, lalu pilih variasi yang ingin Anda buka.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        es: `
        <div class="title-box">Proceso de vinculación de cuenta MT4</div>
                          <p class="bold">
                              Inicie sesión en la cuenta comercial MT4 en el VPS
                          </p>
                  <p>
                      1.1 Utilice el software comercial MT4 integrado de VPS para iniciar sesión en su cuenta, como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Después de abrir el software, puede ver el script WikiFXDefense Sky Eye Shield en la lista de Asesores Expertos en la navegación izquierda, como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Después de iniciar sesión exitosamente en la cuenta comercial, el script Sky Eye Shield se cargará automáticamente en la ventana, como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Si el estado muestra 7 1, significa que la vinculación de la cuenta se realizó correctamente (el script Sky Eye Shield solo detecta la cuenta y no implica ninguna transacción, por lo que no es necesario configurar transacciones automáticas, es decir, el ícono muestra estado después de WikiFXDefense (cara sonriente o cara llorando) No es necesario prestar atención)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Si el estado no muestra 7 1, consulte <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">las preguntas frecuentes</a>.
                  </p>
                  <p>
                      1.6 Si el script WikiFXDefense no aparece en la ventana de tendencias de variedades, se puede cargar manualmente (referencia: método de carga manual MT4 del script WikiFXDefense Sky Eye Shield).
                  </p>

                          <p class="bold">
                              Los usuarios instalan MT4 ellos mismos e inician sesión.
                          </p>

                  <p>
                      2.1 Abra el software MT4 instalado: (aquí se omiten los pasos de instalación). Después de abrir, si el script WikiFXDefense Sky Eye Shield no aparece en la navegación izquierda, como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Puede seleccionar &quot;Asesores expertos&quot;, hacer clic derecho y seleccionar &quot;Actualizar&quot;. Normalmente, el script WikiFX Defense Sky Eye Shield aparecerá automáticamente en la lista (si aún no se muestra, puede esperar un momento y volver a intentarlo). , o comuníquese con el servicio al cliente en línea para obtener ayuda)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Una vez que la cuenta haya iniciado sesión correctamente, cargue manualmente el script WikiFXDefense Sky Eye Shield en la ventana para completar la operación de vinculación de la cuenta.
                  </p>
                  <p>
                      Nota: Una vez que la cuenta se haya vinculado correctamente, el script Sky Eye Shield debe cargarse continuamente (solo se requiere una ventana para cargar). Si cierra esta ventana o carga otros EA en esta ventana, aparecerá un mensaje que prohíbe el cierre. como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Si los usuarios necesitan utilizar otros EA, pueden cargarlos en una nueva ventana (ver más adelante: Cómo abrir la ventana de variedades en MT4).
                  </p>

                          <p class="bold">
                              Método de carga manual MT4 del script WikiFXDefense Sky Eye Shield (igual que la carga normal de otros métodos de EA)
                          </p>

                  <p>
                      Método 1: Haga clic en la ventana del producto que necesita cargar el script WikiFXDefense para activarlo. Luego haga doble clic en el script WikiFXDefense en la lista de navegación, aparecerá una ventana emergente y haga clic en el botón Aceptar. cifra:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Método 2: haga clic con el botón izquierdo del mouse, arrastre el script WikiFXDefense en la lista de navegación a la ventana del producto que debe cargarse, aparecerá una ventana emergente de carga y haga clic en el botón Aceptar.
                  </p>

                          <p class="bold">
                              Cómo abrir la ventana de variedades en MT4
                          </p>

                  <p>
                      Método 1: En la lista de mercados de la izquierda, seleccione la variedad que desea abrir, haga clic con el botón derecho del mouse y seleccione: “Ventana de gráfico”, como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Método 2: en el menú &quot;Ventana&quot;, seleccione &quot;Nueva ventana&quot; y luego seleccione la variedad que desea abrir como se muestra en la figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        hi: `
        <div class="title-box">MT4 खाता बाइंडिंग प्रक्रिया</div>
                          <p class="bold">
                              वीपीएस में एमटी4 ट्रेडिंग खाते में लॉग इन करें
                          </p>
                  <p>
                      1.1 अपने खाते में लॉग इन करने के लिए वीपीएस अंतर्निर्मित एमटी4 ट्रेडिंग सॉफ्टवेयर का उपयोग करें, जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 सॉफ्टवेयर खुलने के बाद, आप बाएं नेविगेशन पर विशेषज्ञ सलाहकार सूची में विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट देख सकते हैं जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 ट्रेडिंग खाते में सफलतापूर्वक लॉग इन करने के बाद, स्काई आई शील्ड स्क्रिप्ट स्वचालित रूप से विंडो में लोड हो जाएगी, जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 यदि स्थिति 7 1s दिखाती है, तो इसका मतलब है कि खाता बाइंडिंग सफल है (स्काई आई शील्ड स्क्रिप्ट केवल खाते का पता लगाती है और इसमें कोई लेनदेन शामिल नहीं है, इसलिए स्वचालित लेनदेन सेट करने की कोई आवश्यकता नहीं है, यानी, आइकन डिस्प्ले WikiFXDefense के बाद की स्थिति (मुस्कुराता हुआ चेहरा या रोता हुआ चेहरा) ध्यान देने की कोई आवश्यकता नहीं)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 यदि स्थिति 7 1 नहीं दिखाती है, तो कृपया <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">अक्सर पूछे जाने वाले प्रश्न</a> देखें।
                  </p>
                  <p>
                      1.6 यदि विकीएफएक्सडिफेंस स्क्रिप्ट वैरायटी ट्रेंड विंडो में दिखाई नहीं देती है, तो इसे मैन्युअल रूप से लोड किया जा सकता है (संदर्भ: विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट की एमटी4 मैनुअल लोडिंग विधि)।
                  </p>

                          <p class="bold">
                              उपयोगकर्ता स्वयं MT4 इंस्टॉल करते हैं और लॉग इन करते हैं।
                          </p>

                  <p>
                      2.1 इंस्टॉल किए गए एमटी4 सॉफ़्टवेयर को खोलें: (इंस्टॉलेशन चरण यहां छोड़े गए हैं)। खोलने के बाद, यदि WikiFXDefense स्काई आई शील्ड स्क्रिप्ट बाएं नेविगेशन में दिखाई नहीं देती है, जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 आप &quot;विशेषज्ञ सलाहकार&quot; का चयन कर सकते हैं, राइट-क्लिक करें और &quot;रीफ्रेश&quot; का चयन करें, आम तौर पर, विकीएफएक्स डिफेंस स्काई आई शील्ड स्क्रिप्ट स्वचालित रूप से सूची में दिखाई देगी (यदि यह अभी भी प्रदर्शित नहीं होती है, तो आप एक क्षण प्रतीक्षा कर सकते हैं और पुनः प्रयास कर सकते हैं , या सहायता के लिए ऑनलाइन ग्राहक सेवा से संपर्क करें)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 खाता सफलतापूर्वक लॉग इन होने के बाद, खाता बाइंडिंग ऑपरेशन को पूरा करने के लिए विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट को मैन्युअल रूप से विंडो में लोड करें।
                  </p>
                  <p>
                      ध्यान दें: खाता सफलतापूर्वक बाउंड होने के बाद, स्काई आई शील्ड स्क्रिप्ट को लगातार लोड करने की आवश्यकता होती है (लोड करने के लिए केवल एक विंडो की आवश्यकता होती है)। जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 यदि उपयोगकर्ताओं को अन्य ईए का उपयोग करने की आवश्यकता है, तो वे उन्हें एक नई विंडो में लोड कर सकते हैं (बाद में देखें: एमटी4 में विविधता विंडो कैसे खोलें)।
                  </p>

                          <p class="bold">
                              WikiFXDefense स्काई आई शील्ड स्क्रिप्ट की MT4 मैन्युअल लोडिंग विधि (अन्य EA विधियों की सामान्य लोडिंग के समान)
                          </p>

                  <p>
                      विधि 1: उस उत्पाद विंडो पर क्लिक करें जिसे WikiFXDefense स्क्रिप्ट को सक्रिय करने के लिए लोड करने की आवश्यकता है। फिर नेविगेशन सूची में WikiFXDefense स्क्रिप्ट पर डबल-क्लिक करें, एक लोडिंग प्रॉम्प्ट विंडो पॉप अप होगी, और ओके बटन पर क्लिक करें आकृति:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      विधि 2: बाईं माउस बटन पर क्लिक करें, नेविगेशन सूची में WikiFXDefense स्क्रिप्ट को उस उत्पाद की विंडो में खींचें जिसे लोड करने की आवश्यकता है, एक लोडिंग प्रॉम्प्ट विंडो पॉप अप हो जाएगी, और ओके बटन पर क्लिक करें।
                  </p>

                          <p class="bold">
                              MT4 में वैरायटी विंडो कैसे खोलें
                          </p>

                  <p>
                      विधि 1: बाईं ओर बाजार सूची में, वह किस्म चुनें जिसे आप खोलना चाहते हैं, माउस पर राइट-क्लिक करें और चुनें: &quot;चार्ट विंडो&quot;।
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      विधि 2: मेनू &quot;विंडो&quot; में, &quot;नई विंडो&quot; चुनें, और फिर वह किस्म चुनें जिसे आप खोलना चाहते हैं जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        fil: `
        <div class="title-box">Proseso ng pagbubuklod ng MT4 account</div>
                          <p class="bold">
                              Mag-log in sa MT4 trading account sa VPS
                          </p>
                  <p>
                      1.1 Gamitin ang VPS built-in na MT4 trading software upang mag-log in sa iyong account, tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Pagkatapos mabuksan ang software, makikita mo ang script ng WikiFXDefense Sky Eye Shield sa listahan ng Expert Advisors sa kaliwang nabigasyon Gaya ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Pagkatapos ng matagumpay na pag-log in sa trading account, awtomatikong mai-load ang Sky Eye Shield script sa window, tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Kung ang Status ay nagpapakita ng 7 1s, nangangahulugan ito na ang account binding ay matagumpay (ang Sky Eye Shield script ay gumagawa lamang ng pag-detect ng account at hindi nagsasangkot ng anumang mga transaksyon, kaya hindi na kailangang mag-set up ng mga awtomatikong transaksyon, iyon ay, ang pagpapakita ng icon katayuan pagkatapos ng WikiFXDefense (nakangiting mukha o umiiyak na mukha) )Hindi na kailangang bigyang pansin)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Kung ang Status ay hindi nagpapakita ng 7 1s, mangyaring sumangguni sa mga <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>.
                  </p>
                  <p>
                      1.6 Kung ang script ng WikiFXDefense ay hindi lumabas sa window ng variety trend, maaari itong i-load nang manu-mano (reference: MT4 manual loading method ng WikiFXDefense Sky Eye Shield script).
                  </p>

                          <p class="bold">
                              Ang mga gumagamit ay nag-install ng MT4 sa kanilang sarili at nag-log in.
                          </p>

                  <p>
                      2.1 Buksan ang naka-install na MT4 software: (ang mga hakbang sa pag-install ay tinanggal dito). Pagkatapos buksan, kung ang script ng WikiFXDefense Sky Eye Shield ay hindi lilitaw sa kaliwang nabigasyon, tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Maaari mong piliin ang &quot;Mga Expert Advisors&quot;, i-right-click at piliin ang &quot;I-refresh&quot;. , o makipag-ugnayan sa online na customer service para sa tulong)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Matapos matagumpay na mai-log in ang account, manu-manong i-load ang script ng WikiFXDefense Sky Eye Shield sa window upang makumpleto ang pagpapatakbo ng account binding.
                  </p>
                  <p>
                      Tandaan: Pagkatapos na matagumpay na ma-bound ang account, kailangang patuloy na i-load ang script ng Sky Eye Shield (isang window lang ang kailangan upang mai-load ang window na ito o mag-load ng iba pang EA sa window na ito, lalabas ang isang prompt na nagbabawal sa pagsasara). tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Kung kailangan ng mga user na gumamit ng iba pang EA, maaari nilang i-load ang mga ito sa isang bagong window (tingnan sa ibang pagkakataon: Paano buksan ang variety window sa MT4).
                  </p>

                          <p class="bold">
                              MT4 manual loading method ng WikiFXDefense Sky Eye Shield script (katulad ng normal na paglo-load ng iba pang paraan ng EA)
                          </p>

                  <p>
                      Paraan 1: Mag-click sa window ng produkto na kailangang i-load ang script ng WikiFXDefense upang gawin itong aktibo figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Paraan 2: I-click ang kaliwang pindutan ng mouse, i-drag ang script ng WikiFXDefense sa listahan ng nabigasyon sa window ng produkto na kailangang i-load, lalabas ang isang window ng prompt sa paglo-load, at i-click ang OK na buton.
                  </p>

                          <p class="bold">
                              Paano buksan ang variety window sa MT4
                          </p>

                  <p>
                      Paraan 1: Sa listahan ng market sa kaliwa, piliin ang iba&#39;t-ibang gusto mong buksan, i-right-click ang mouse at piliin ang: &quot;Chart Window&quot;.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Paraan 2: Sa menu na &quot;Window&quot;, piliin ang &quot;Bagong Window&quot;, at pagkatapos ay piliin ang iba&#39;t-ibang gusto mong buksan Gaya ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        fr: `
        <div class="title-box">Processus de liaison de compte MT4</div>
                          <p class="bold">
                              Connectez-vous au compte de trading MT4 dans le VPS
                          </p>
                  <p>
                      1.1 Utilisez le logiciel de trading MT4 intégré à VPS pour vous connecter à votre compte, comme indiqué dans la figure&nbsp;:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Une fois le logiciel ouvert, vous pouvez voir le script WikiFXDefense Sky Eye Shield dans la liste des conseillers experts dans la navigation de gauche, comme le montre la figure&nbsp;:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Après vous être connecté avec succès au compte de trading, le script Sky Eye Shield sera automatiquement chargé dans la fenêtre, comme le montre la figure&nbsp;:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Si l&#39;état indique 7 1, cela signifie que la liaison du compte est réussie (le script Sky Eye Shield détecte uniquement le compte et n&#39;implique aucune transaction, il n&#39;est donc pas nécessaire de configurer des transactions automatiques, c&#39;est-à-dire que l&#39;icône s&#39;affiche. statut après WikiFXDefense (visage souriant ou visage qui pleure) )Pas besoin de faire attention)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Si le statut n&#39;affiche pas 7 1, veuillez vous référer à la <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>.
                  </p>
                  <p>
                      1.6 Si le script WikiFXDefense n&#39;apparaît pas dans la fenêtre des tendances de variétés, il peut être chargé manuellement (référence&nbsp;: méthode de chargement manuel MT4 du script WikiFXDefense Sky Eye Shield).
                  </p>

                          <p class="bold">
                              Les utilisateurs installent eux-mêmes MT4 et se connectent.
                          </p>

                  <p>
                      2.1 Ouvrez le logiciel MT4 installé&nbsp;: (les étapes d&#39;installation sont omises ici). Après ouverture, si le script WikiFXDefense Sky Eye Shield n&#39;apparaît pas dans la navigation de gauche, comme le montre la figure&nbsp;:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Vous pouvez sélectionner « Expert Advisors », faire un clic droit et sélectionner « Actualiser ». Normalement, le script WikiFX Defense Sky Eye Shield apparaîtra automatiquement dans la liste (s&#39;il n&#39;est toujours pas affiché, vous pouvez attendre un moment et réessayer. , ou contactez le service client en ligne pour obtenir de l&#39;aide)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Une fois le compte connecté avec succès, chargez manuellement le script WikiFXDefense Sky Eye Shield dans la fenêtre pour terminer l&#39;opération de liaison du compte.
                  </p>
                  <p>
                      Remarque&nbsp;: Une fois le compte lié avec succès, le script Sky Eye Shield doit être chargé en continu (une seule fenêtre est requise pour le chargement). Si vous fermez cette fenêtre ou chargez d&#39;autres EA dans cette fenêtre, une invite interdisant la fermeture apparaîtra. comme le montre la figure&nbsp;:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Si les utilisateurs ont besoin d&#39;utiliser d&#39;autres EA, ils peuvent les charger dans une nouvelle fenêtre (voir plus tard : Comment ouvrir la fenêtre des variétés dans MT4).
                  </p>

                          <p class="bold">
                              Méthode de chargement manuel MT4 du script WikiFXDefense Sky Eye Shield (identique au chargement normal des autres méthodes EA)
                          </p>

                  <p>
                      Méthode 1&nbsp;: cliquez sur la fenêtre du produit qui doit charger le script WikiFXDefense pour le rendre actif. Ensuite, double-cliquez sur le script WikiFXDefense dans la liste de navigation, une fenêtre d&#39;invite de chargement apparaîtra et cliquez sur le bouton OK comme indiqué dans l&#39;image. chiffre:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Méthode 2&nbsp;: cliquez sur le bouton gauche de la souris, faites glisser le script WikiFXDefense dans la liste de navigation vers la fenêtre du produit qui doit être chargé, une fenêtre d&#39;invite de chargement apparaîtra et cliquez sur le bouton OK.
                  </p>

                          <p class="bold">
                              Comment ouvrir la fenêtre des variétés dans MT4
                          </p>

                  <p>
                      Méthode 1&nbsp;: Dans la liste des marchés à gauche, sélectionnez la variété que vous souhaitez ouvrir, cliquez avec le bouton droit de la souris et sélectionnez&nbsp;: «&nbsp;Fenêtre graphique&nbsp;».
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Méthode 2 : Dans le menu « Fenêtre », sélectionnez « Nouvelle fenêtre », puis sélectionnez la variété que vous souhaitez ouvrir comme le montre la figure :
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        de: `
        <div class="title-box">MT4-Kontobindungsprozess</div>
                          <p class="bold">
                              Melden Sie sich beim MT4-Handelskonto im VPS an
                          </p>
                  <p>
                      1.1 Verwenden Sie die in VPS integrierte MT4-Handelssoftware, um sich bei Ihrem Konto anzumelden, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Nachdem die Software geöffnet wurde, können Sie das WikiFXDefense Sky Eye Shield-Skript in der Expert Advisors-Liste in der linken Navigation sehen, wie in der Abbildung dargestellt:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Nach erfolgreicher Anmeldung beim Handelskonto wird das Sky Eye Shield-Skript automatisch in das Fenster geladen, wie in der Abbildung dargestellt:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Wenn der Status 7 Einsen anzeigt, bedeutet dies, dass die Kontobindung erfolgreich war (das Sky Eye Shield-Skript führt nur die Kontoerkennung durch und beinhaltet keine Transaktionen, sodass keine Notwendigkeit besteht, automatische Transaktionen einzurichten, d. h. die Symbolanzeige). Status nach WikiFXDefense (lächelndes Gesicht oder weinendes Gesicht) )Kein Grund zur Beachtung)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Wenn der Status nicht 7 1 anzeigt, lesen Sie bitte die <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQs</a>.
                  </p>
                  <p>
                      1.6 Wenn das WikiFXDefense-Skript nicht im Sortentrendfenster angezeigt wird, kann es manuell geladen werden (Referenz: Manuelle MT4-Lademethode des WikiFXDefense Sky Eye Shield-Skripts).
                  </p>

                          <p class="bold">
                              Benutzer installieren MT4 selbst und melden sich an.
                          </p>

                  <p>
                      2.1 Öffnen Sie die installierte MT4-Software: (Die Installationsschritte entfallen hier). Wenn das WikiFXDefense Sky Eye Shield-Skript nach dem Öffnen nicht in der linken Navigation erscheint, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Sie können „Expert Advisors“ auswählen, mit der rechten Maustaste klicken und „Aktualisieren“ auswählen. Normalerweise wird das WikiFX Defense Sky Eye Shield-Skript automatisch in der Liste angezeigt (Wenn es immer noch nicht angezeigt wird, können Sie einen Moment warten und es erneut versuchen , oder kontaktieren Sie den Online-Kundendienst für Hilfe)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Nachdem das Konto erfolgreich angemeldet wurde, laden Sie das WikiFXDefense Sky Eye Shield-Skript manuell in das Fenster, um den Kontobindungsvorgang abzuschließen.
                  </p>
                  <p>
                      Hinweis: Nachdem das Konto erfolgreich gebunden wurde, muss das Sky Eye Shield-Skript kontinuierlich geladen werden (zum Laden ist nur ein Fenster erforderlich. Wenn Sie dieses Fenster schließen oder andere EAs in diesem Fenster laden, wird eine Meldung angezeigt, die das Schließen verbietet). wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Wenn Benutzer andere EAs verwenden müssen, können sie diese in einem neuen Fenster laden (siehe später: So öffnen Sie das Sortenfenster in MT4).
                  </p>

                          <p class="bold">
                              Manuelle MT4-Lademethode des WikiFXDefense Sky Eye Shield-Skripts (identisch mit dem normalen Laden anderer EA-Methoden)
                          </p>

                  <p>
                      Methode 1: Klicken Sie auf das Produktfenster, das das WikiFXDefense-Skript laden muss, um es zu aktivieren. Doppelklicken Sie dann auf das WikiFXDefense-Skript in der Navigationsliste. Ein Fenster mit der Ladeaufforderung wird angezeigt, und Sie klicken auf die Schaltfläche „OK“. Figur:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Methode 2: Klicken Sie mit der linken Maustaste, ziehen Sie das WikiFXDefense-Skript aus der Navigationsliste in das Fenster des Produkts, das geladen werden muss. Es erscheint ein Fenster mit einer Ladeaufforderung, und klicken Sie auf die Schaltfläche „OK“.
                  </p>

                          <p class="bold">
                              So öffnen Sie das Sortenfenster in MT4
                          </p>

                  <p>
                      Methode 1: Wählen Sie in der Marktliste links die Sorte aus, die Sie öffnen möchten, klicken Sie mit der rechten Maustaste und wählen Sie: „Chart-Fenster“.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Methode 2: Wählen Sie im Menü „Fenster“ „Neues Fenster“ und wählen Sie dann die Sorte aus, die Sie öffnen möchten, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        pt: `
        <div class="title-box">Processo de vinculação de conta MT4</div>
                          <p class="bold">
                              Faça login na conta de negociação MT4 no VPS
                          </p>
                  <p>
                      1.1 Use o software de negociação MT4 integrado ao VPS para fazer login em sua conta, conforme mostrado na figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Depois que o software for aberto, você poderá ver o script WikiFXDefense Sky Eye Shield na lista de Expert Advisors na navegação esquerda, conforme mostrado na figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Após fazer login com sucesso na conta de negociação, o script Sky Eye Shield será carregado automaticamente na janela, conforme mostrado na figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Se o Status mostrar 7 1s, significa que a vinculação da conta foi bem-sucedida (o script Sky Eye Shield apenas faz detecção de conta e não envolve nenhuma transação, portanto não há necessidade de configurar transações automáticas, ou seja, a exibição do ícone status após WikiFXDefense (rosto sorridente ou choroso))Não há necessidade de prestar atenção)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Se o Status não mostrar 7 1s, consulte as <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">Perguntas Frequentes</a>.
                  </p>
                  <p>
                      1.6 Se o script WikiFXDefense não aparecer na janela de tendências de variedade, ele pode ser carregado manualmente (referência: método de carregamento manual MT4 do script WikiFXDefense Sky Eye Shield).
                  </p>

                          <p class="bold">
                              Os próprios usuários instalam o MT4 e fazem login.
                          </p>

                  <p>
                      2.1 Abra o software MT4 instalado: (as etapas de instalação são omitidas aqui). Após a abertura, se o script WikiFXDefense Sky Eye Shield não aparecer na navegação esquerda, conforme mostrado na figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 Você pode selecionar &quot;Expert Advisors&quot;, clicar com o botão direito e selecionar &quot;Atualizar&quot;. Normalmente, o script WikiFX Defense Sky Eye Shield aparecerá automaticamente na lista (se ainda não for exibido, você pode esperar um momento e tentar novamente. ou entre em contato com o atendimento ao cliente on-line para obter assistência)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Após o login bem-sucedido da conta, carregue manualmente o script WikiFXDefense Sky Eye Shield na janela para concluir a operação de vinculação da conta.
                  </p>
                  <p>
                      Nota: Depois que a conta for vinculada com sucesso, o script Sky Eye Shield precisa ser carregado continuamente (apenas uma janela é necessária para carregar, se você fechar esta janela ou carregar outros EAs nesta janela, um prompt proibindo o fechamento aparecerá). como mostrado na figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Se os usuários precisarem usar outros EAs, eles poderão carregá-los em uma nova janela (veja mais tarde: Como abrir a janela de variedades no MT4).
                  </p>

                          <p class="bold">
                              Método de carregamento manual MT4 do script WikiFXDefense Sky Eye Shield (igual ao carregamento normal de outros métodos EA)
                          </p>

                  <p>
                      Método 1: Clique na janela do produto que precisa carregar o script WikiFXDefense para torná-lo ativo. Em seguida, clique duas vezes no script WikiFXDefense na lista de navegação, uma janela de prompt de carregamento aparecerá e clique no botão OK conforme mostrado no. figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Método 2: Clique com o botão esquerdo do mouse, arraste o script WikiFXDefense da lista de navegação para a janela do produto que precisa ser carregado, uma janela de prompt de carregamento aparecerá e clique no botão OK.
                  </p>

                          <p class="bold">
                              Como abrir a janela de variedades no MT4
                          </p>

                  <p>
                      Método 1: Na lista de mercados à esquerda, selecione a variedade que deseja abrir, clique com o botão direito do mouse e selecione: “Janela de gráfico”.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Método 2: No menu “Janela”, selecione “Nova Janela” e a seguir selecione a variedade que deseja abrir conforme mostrado na figura:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        tr: `
        <div class="title-box">MT4 hesap bağlama işlemi</div>
                          <p class="bold">
                              VPS&#39;deki MT4 ticaret hesabında oturum açın
                          </p>
                  <p>
                      1.1 Şekilde gösterildiği gibi, hesabınızda oturum açmak için VPS&#39;nin yerleşik MT4 ticaret yazılımını kullanın:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Yazılım açıldıktan sonra, WikiFXDefense Sky Eye Shield betiğini soldaki navigasyondaki Uzman Danışmanlar listesinde görebilirsiniz.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Ticaret hesabında başarılı bir şekilde oturum açtıktan sonra Sky Eye Shield komut dosyası, şekilde gösterildiği gibi otomatik olarak pencereye yüklenecektir:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Durum 7 1 gösteriyorsa, bu hesap bağlamanın başarılı olduğu anlamına gelir (Sky Eye Shield komut dosyası yalnızca hesap algılama yapar ve herhangi bir işlem içermez, dolayısıyla otomatik işlemler ayarlamaya, yani simge görüntülemeye gerek yoktur) WikiFXDefense&#39;den sonraki durum (gülen yüz veya ağlayan yüz) )Dikkat etmeye gerek yok)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Durumda 7 1 görünmüyorsa lütfen <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">SSS&#39;a bakın</a>.
                  </p>
                  <p>
                      1.6 WikiFXDefense komut dosyası çeşitlilik eğilimi penceresinde görünmüyorsa, manuel olarak yüklenebilir (referans: WikiFXDefense Sky Eye Shield komut dosyasının MT4 manuel yükleme yöntemi).
                  </p>

                          <p class="bold">
                              Kullanıcılar MT4&#39;ü kendileri kurup giriş yaparlar.
                          </p>

                  <p>
                      2.1 Kurulu MT4 yazılımını açın: (kurulum adımları burada atlanmıştır). Açıldıktan sonra, WikiFXDefense Sky Eye Shield betiği şekilde gösterildiği gibi sol gezinme bölmesinde görünmüyorsa:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 &quot;Uzman Danışmanlar&quot;ı seçip sağ tıklayıp &quot;Yenile&quot;yi seçebilirsiniz. Normalde WikiFX Defense Sky Eye Shield betiği otomatik olarak listede görünecektir (Eğer hala görüntülenmiyorsa, bir süre bekleyip tekrar deneyebilirsiniz. veya yardım için çevrimiçi müşteri hizmetlerine başvurun)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 Hesapta başarıyla oturum açıldıktan sonra, hesap bağlama işlemini tamamlamak için WikiFXDefense Sky Eye Shield komut dosyasını manuel olarak pencereye yükleyin.
                  </p>
                  <p>
                      Not: Hesap başarılı bir şekilde bağlandıktan sonra Sky Eye Shield betiğinin sürekli olarak yüklenmesi gerekir (yüklemek için yalnızca bir pencere gerekir). Bu pencereyi kapatırsanız veya bu pencereye başka EA&#39;lar yüklerseniz, kapatmayı yasaklayan bir istem açılacaktır. şekilde gösterildiği gibi:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 Kullanıcıların başka EA&#39;ları kullanması gerekiyorsa, bunları yeni bir pencereye yükleyebilirler (daha sonra bakınız: MT4&#39;te çeşitlilik penceresi nasıl açılır).
                  </p>

                          <p class="bold">
                              WikiFXDefense Sky Eye Shield komut dosyasının MT4 manuel yükleme yöntemi (diğer EA yöntemlerinin normal yüklenmesiyle aynı)
                          </p>

                  <p>
                      Yöntem 1: WikiFXDefense betiğini aktif hale getirmek için yüklemesi gereken ürün penceresine tıklayın. Ardından gezinme listesinde WikiFXDefense betiğine çift tıklayın, bir yükleme istemi penceresi açılacaktır ve Şekilde gösterildiği gibi Tamam düğmesine tıklayın. figür:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      Yöntem 2: Sol fare düğmesine tıklayın, gezinme listesindeki WikiFXDefense komut dosyasını yüklenmesi gereken ürünün penceresine sürükleyin, bir yükleme istemi penceresi açılacaktır ve Tamam düğmesine tıklayın.
                  </p>

                          <p class="bold">
                              MT4&#39;te çeşitlilik penceresi nasıl açılır?
                          </p>

                  <p>
                      Yöntem 1: Soldaki piyasa listesinde açmak istediğiniz çeşidi seçin, fareye sağ tıklayın ve “Grafik Penceresi” seçeneğini seçin. Şekilde gösterildiği gibi:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      Yöntem 2: &quot;Pencere&quot; menüsünde &quot;Yeni Pencere&quot;yi seçin ve ardından açmak istediğiniz çeşidi seçin. Şekilde gösterildiği gibi:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        ko: `
        <div class="title-box">MT4 계정 바인딩 프로세스</div>
                          <p class="bold">
                              VPS에서 MT4 거래 계좌에 로그인하세요.
                          </p>
                  <p>
                      1.1 그림과 같이 VPS 내장 MT4 거래 소프트웨어를 사용하여 계정에 로그인하십시오.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 소프트웨어가 열리면 그림과 같이 왼쪽 탐색 메뉴의 Expert Advisors 목록에서 WikiFXDefense Sky Eye Shield 스크립트를 볼 수 있습니다.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 거래 계좌에 성공적으로 로그인하면 그림과 같이 Sky Eye Shield 스크립트가 자동으로 창에 로드됩니다.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 상태에 7 1이 표시되면 계정 바인딩이 성공한 것입니다. (Sky Eye Shield 스크립트는 계정 감지만 수행하고 거래는 포함하지 않으므로 자동 거래를 설정할 필요가 없습니다. 즉, 아이콘 표시 WikiFXDefense 이후 상태(웃는 얼굴 또는 우는 얼굴)) 주의할 필요 없음)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 상태에 7 1이 표시되지 않으면 <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>를 참조하세요.
                  </p>
                  <p>
                      1.6 WikiFXDefense 스크립트가 버라이어티 트렌드 창에 나타나지 않는 경우, 수동으로 로딩할 수 있습니다(참조: WikiFXDefense Sky Eye Shield 스크립트의 MT4 수동 로딩 방법).
                  </p>

                          <p class="bold">
                              사용자가 직접 MT4를 설치하고 로그인합니다.
                          </p>

                  <p>
                      2.1 설치된 MT4 소프트웨어를 엽니다. (여기에서는 설치 단계가 생략됩니다.) 연 후 그림과 같이 WikiFXDefense Sky Eye Shield 스크립트가 왼쪽 탐색에 표시되지 않는 경우:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 &quot;Expert Advisors&quot;를 선택하고 마우스 오른쪽 버튼을 클릭한 후 &quot;새로 고침&quot;을 선택할 수 있습니다. 일반적으로 WikiFX Defense Sky Eye Shield 스크립트가 자동으로 목록에 표시됩니다. (아직 표시되지 않으면 잠시 기다렸다가 다시 시도하세요.) , 또는 온라인 고객 서비스에 문의하여 도움을 받으세요)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 계정이 성공적으로 로그인된 후 WikiFXDefense Sky Eye Shield 스크립트를 창에 수동으로 로드하여 계정 바인딩 작업을 완료합니다.
                  </p>
                  <p>
                      참고: 계정이 성공적으로 바인딩된 후 Sky Eye Shield 스크립트를 계속 로드해야 합니다(로드하려면 하나의 창만 필요함). 이 창을 닫거나 이 창에서 다른 EA를 로드하면 폐쇄를 금지하는 메시지가 나타납니다. 그림과 같이 :
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 사용자가 다른 EA를 사용해야 하는 경우 새 창에서 로드할 수 있습니다(나중에 MT4에서 다양한 창을 여는 방법 참조).
                  </p>

                          <p class="bold">
                              WikiFXDefense Sky Eye Shield 스크립트의 MT4 수동 로딩 방법 (다른 EA 방법의 일반 로딩과 동일)
                          </p>

                  <p>
                      방법 1: WikiFXDefense 스크립트를 로드해야 하는 제품 창을 클릭하여 활성화합니다. 그런 다음 탐색 목록에서 WikiFXDefense 스크립트를 두 번 클릭하면 로딩 프롬프트 창이 팝업되고 확인 버튼을 클릭합니다. 수치:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      방법 2: 마우스 왼쪽 버튼을 클릭하고 탐색 목록의 WikiFXDefense 스크립트를 로드해야 하는 제품 창으로 드래그하면 로딩 프롬프트 창이 팝업되고 확인 버튼을 클릭합니다.
                  </p>

                          <p class="bold">
                              MT4에서 버라이어티 창을 여는 방법
                          </p>

                  <p>
                      방법 1: 왼쪽 시장 목록에서 열려는 품종을 선택하고 마우스 오른쪽 버튼을 클릭한 다음 그림과 같이 &quot;차트 창&quot;을 선택합니다.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      방법 2: &quot;창&quot; 메뉴에서 &quot;새 창&quot;을 선택한 다음 그림과 같이 열려는 다양한 항목을 선택합니다.
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`,
        ar: `
        <div class="title-box">عملية ربط حساب MT4</div>
                          <p class="bold">
                              قم بتسجيل الدخول إلى حساب التداول MT4 في الخادم الافتراضي الخاص (VPS).
                          </p>
                  <p>
                      1.1 استخدم برنامج التداول MT4 المدمج في VPS لتسجيل الدخول إلى حسابك، كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 بعد فتح البرنامج، يمكنك رؤية البرنامج النصي WikiFXDefense Sky Eye Shield في قائمة المستشارين الخبراء في شريط التنقل الأيسر كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 بعد تسجيل الدخول بنجاح إلى حساب التداول، سيتم تحميل البرنامج النصي Sky Eye Shield تلقائيًا في النافذة، كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 إذا أظهرت الحالة 7 1، فهذا يعني أن ربط الحساب ناجح (البرنامج النصي Sky Eye Shield يقوم فقط بالكشف عن الحساب ولا يتضمن أي معاملات، لذلك ليست هناك حاجة لإعداد المعاملات التلقائية، أي عرض الرمز الحالة بعد WikiFXDefense (الوجه المبتسم أو الوجه الباكي) (لا داعي للانتباه)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon4.png')}"/>
                  </p>
                  <p>
                    1.5 إذا لم تظهر الحالة 7 1،<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">فيرجى الرجوع إلى الأسئلة الشائعة.</a>
                  </p>
                  <p>
                      1.6 إذا لم يظهر البرنامج النصي WikiFXDefense في نافذة الاتجاه المتنوع، فيمكن تحميله يدويًا (المرجع: طريقة التحميل اليدوي MT4 للبرنامج النصي WikiFXDefense Sky Eye Shield).
                  </p>

                          <p class="bold">
                              يقوم المستخدمون بتثبيت MT4 بأنفسهم وتسجيل الدخول.
                          </p>

                  <p>
                      2.1 افتح برنامج MT4 المثبت: (تم حذف خطوات التثبيت هنا). بعد الفتح، إذا لم يظهر البرنامج النصي WikiFXDefense Sky Eye Shield في شريط التنقل الأيسر، كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon5.png')}"/>
                  </p>
                  <p>
                      2.2 يمكنك تحديد &quot;المستشارون الخبراء&quot;، والنقر بزر الماوس الأيمن وتحديد &quot;تحديث&quot;. عادةً، سيظهر البرنامج النصي WikiFX Defense Sky Eye Shield تلقائيًا في القائمة (إذا لم يتم عرضه بعد، يمكنك الانتظار لحظة والمحاولة مرة أخرى أو اتصل بخدمة العملاء عبر الإنترنت للحصول على المساعدة)
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon6.png')}"/>
                  </p>
                  <p>
                      2.3 بعد تسجيل الدخول إلى الحساب بنجاح، قم بتحميل البرنامج النصي WikiFXDefense Sky Eye Shield يدويًا في النافذة لإكمال عملية ربط الحساب.
                  </p>
                  <p>
                      ملاحظة: بعد ربط الحساب بنجاح، يجب تحميل البرنامج النصي Sky Eye Shield بشكل مستمر (يلزم تحميل نافذة واحدة فقط إذا قمت بإغلاق هذه النافذة أو تحميل مناطق العد الأخرى في هذه النافذة، ستظهر رسالة تحظر الإغلاق). كما هو مبين في الشكل:
                  </p>
                  <p>
                      [
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon7.png')}"/>
                  </p>
                  <p>
                      2.4 إذا كان المستخدمون بحاجة إلى استخدام مناطق العد الأخرى، فيمكنهم تحميلها في نافذة جديدة (انظر لاحقًا: كيفية فتح نافذة التنوع في MT4).
                  </p>

                          <p class="bold">
                              طريقة التحميل اليدوي MT4 لبرنامج WikiFXDefense Sky Eye Shield (مثل التحميل العادي لطرق EA الأخرى)
                          </p>

                  <p>
                      الطريقة الأولى: انقر فوق نافذة المنتج التي تحتاج إلى تحميل البرنامج النصي WikiFXDefense لتنشيطه، ثم انقر نقرًا مزدوجًا فوق البرنامج النصي WikiFXDefense في قائمة التنقل، ستظهر نافذة مطالبة بالتحميل، وانقر فوق الزر &quot;موافق&quot;. شكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon8.png')}"/>
                  </p>
                  <p>
                      الطريقة الثانية: انقر فوق زر الماوس الأيسر، واسحب البرنامج النصي WikiFXDefense في قائمة التنقل إلى نافذة المنتج الذي يجب تحميله، وستنبثق نافذة مطالبة التحميل، وانقر فوق الزر &quot;موافق&quot;.
                  </p>

                          <p class="bold">
                              كيفية فتح نافذة التنوع في MT4
                          </p>

                  <p>
                      الطريقة الأولى: في قائمة السوق الموجودة على اليسار، حدد الصنف الذي تريد فتحه، وانقر بزر الماوس الأيمن وحدد: &quot;نافذة الرسم البياني&quot; كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon9.png')}"/>
                  </p>
                  <p>
                      الطريقة الثانية: في القائمة &quot;نافذة&quot;، حدد &quot;نافذة جديدة&quot;، ثم حدد الصنف الذي تريد فتحه، كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                    <img src="${require('~/assets/img/help/mt4-icon10.png')}"/>
                  </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('40599'),
      meta: [
        { name: 'Description', content: this.$t('40588') }
      ]
    }
  }
}
